import { render, staticRenderFns } from "./FinancedProjectsTab.vue?vue&type=template&id=4ab8fff0&scoped=true"
import script from "./FinancedProjectsTab.vue?vue&type=script&lang=js"
export * from "./FinancedProjectsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab8fff0",
  null
  
)

export default component.exports